import angular from 'angular';
import AuthService from '@/shared/services/AuthService';

angular
  .module('cxRelations')
  .controller('RelationFileCtrl', ['relBindSvc', '$state', '$filter', relationFileCtrl]);

function relationFileCtrl(relBindSvc, $state, $filter) {
  var vm = this;

  function updateBrowserTitle(relation) {
    if (AuthService.isSupport()) return;
    if (relation) {
      var name = $filter('relationName')(relation);
      if (name) document.title = name + ' - AdminPulse';
    }
  }

  vm.$onInit = function() {
    vm.relations = relBindSvc.relations;
    vm.current = relBindSvc.active;
    vm.relationId = $state.params.relId || relBindSvc.active.id;

    if ($state.params.relId) {
      vm.relationId = $state.params.relId;
    } else if (relBindSvc.active.id) {
      vm.relationId = relBindSvc.active.id;
    }

    if (!vm.relationId) {
      $state.go('relations.overview');
    }
    if (
      !vm.relations[vm.relationId] ||
      (!vm.relations[vm.relationId].sections && !vm.relations[vm.relationId].loading) ||
      (!$state.params.fromRelBindSvc && !vm.relations[vm.relationId].loading)
    )
      relBindSvc.open(vm.relationId).then(updateBrowserTitle);
    else if (!vm.relations[vm.relationId].loading) updateBrowserTitle(vm.relations[vm.relationId]);
    else relBindSvc.open(vm.relationId, { reload: false }).then(updateBrowserTitle);
  };
}
